import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './plugins/axios'
import './scss/variables.scss'
import './scss/overrides.scss'

import VersionController from './plugins/version-controller.js'
Vue.use(VersionController)

import VueClock from './components/clock/index.js'
Vue.use(VueClock)

import TimezonePlugin from './plugins/timezone.js'
Vue.use(TimezonePlugin)

import VueLodash from './plugins/lodash'
Vue.use(VueLodash)

import Vue2Editor from "vue2-editor";
Vue.use(Vue2Editor);

import Components from './plugins/components'
Vue.use(Components)

import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);


import watermark from 'vue-watermark-directive'
const WATERMARK_CONFIG = {
  zIndex: 1000,
  font: '20px microsoft yahei',
  color: 'rgba(0,0,0,0.05)',
  rotate: 25,
  width: 200,
  repeat: true
}
Vue.use(watermark, WATERMARK_CONFIG)
// import VueTour from 'vue-tour'
// require('vue-tour/dist/vue-tour.css')
// Vue.use(VueTour)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
